export default "Isolation de toiture-terrasse pour patrimoine tertiaire (fiche CEE BAT-EN-101). Levier-clé pour les bâtiments construits avant la RT 2005. Compatible réfection d'étanchéité.";
